export function startOfDay(date: Date): Date {
  const next = new Date(date);
  next.setHours(0, 0, 0, 0);
  return next;
}

export type DateRangeYmd = {
  startDate: string;
  endDate: string;
};

export function parseDateString(value: string): Date | undefined {
  if (!value) return undefined;
  const [year, month, day] = value.split("-").map(Number);
  if (!year || !month || !day) return undefined;
  return new Date(year, month - 1, day);
}

export function formatDateString(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function isBeforeMinDate(date: Date, minDate?: Date): boolean {
  if (!minDate) return false;
  return startOfDay(date).getTime() < startOfDay(minDate).getTime();
}

export function buildMinDateDisabled(minDate?: Date) {
  return (date: Date) => isBeforeMinDate(date, minDate);
}

export function rangesOverlap(
  startA: string,
  endA: string,
  startB: string,
  endB: string
): boolean {
  const a0 = parseDateString(startA);
  const a1 = parseDateString(endA);
  const b0 = parseDateString(startB);
  const b1 = parseDateString(endB);
  if (!a0 || !a1 || !b0 || !b1) return false;
  const t0 = startOfDay(a0).getTime();
  const t1 = startOfDay(a1).getTime();
  const u0 = startOfDay(b0).getTime();
  const u1 = startOfDay(b1).getTime();
  return t0 <= u1 && u0 <= t1;
}

export function isDateInRange(date: Date, startStr: string, endStr: string): boolean {
  const s = parseDateString(startStr);
  const e = parseDateString(endStr);
  if (!s || !e) return false;
  const t = startOfDay(date).getTime();
  return t >= startOfDay(s).getTime() && t <= startOfDay(e).getTime();
}

export function isDateInAnyRanges(date: Date, ranges: DateRangeYmd[]): boolean {
  return ranges.some((r) => isDateInRange(date, r.startDate, r.endDate));
}

export function intervalOverlapsRanges(
  startStr: string,
  endStr: string,
  ranges: DateRangeYmd[]
): boolean {
  if (!startStr || !endStr) return false;
  const s = parseDateString(startStr);
  const e = parseDateString(endStr);
  if (!s || !e) return false;
  if (startOfDay(e).getTime() < startOfDay(s).getTime()) return false;
  return ranges.some((r) => rangesOverlap(startStr, endStr, r.startDate, r.endDate));
}
